import {ActivityIndicator, View} from "react-native";
import React, {useContext} from "react";
import qrLoadingLottie from "../assets/qr_loading_lottie.json";
import {useLottie} from "lottie-react";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";

function QrLoading(){
    const { View  } = useLottie({
        animationData: qrLoadingLottie,
        loop: true
    });
    return <>{View}</>;
}

export default function ProgressView(props:any){
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return props.show ?
        <View style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <View style={{
                flexGrow: 1,
                backgroundColor: colors.get("transparentPrimary") as string,
                opacity: .69,
                position: "absolute",
                width: "100%",
                height: "100%",
            }}/>
            <View style={{maxWidth: 100, maxHeight: 100}}>

<ActivityIndicator size={50} color={colors.get("primaryColor") as string}/>
            </View>
        </View> : <></>
}